import { render, staticRenderFns } from "./SiteGroupFilter.vue?vue&type=template&id=2b84df18&"
import script from "./SiteGroupFilter.vue?vue&type=script&lang=js&"
export * from "./SiteGroupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports